import request from '@/utils/request'


/**
 * 产品列表
 */
 export function getProductList(params) {
  return request({
    url: `/front/article/list`,
    method: 'GET',
    params
  })
}

/**
 * 新闻列表
 */
 export function getArticleList(params) {
  return request({
    url: `/front/forum/topic/list`,
    method: 'GET',
    params
  })
}

/**
 * 新闻详情
 */
 export function getArticleDetail(params) {
  return request({
    url: `/front/forum/topic/info`,
    method: 'GET',
    params
  })
}

/**
 * 产品详情
 */
 export function getProductDetail(params) {
  return request({
    url: `/front/article/info`,
    method: 'GET',
    params
  })
}

